import { presentParticipantStatuses } from 'app/frontend/types/custom/EventParticipantStatus'
import { minRaidSize } from 'app/frontend/base/helpers/raidSize'

export const participantColor = (
  event: wowaudit.EventReference,
  gameVersion: wowaudit.PageInfo['gameVersion'],
) => {
  const presentCount = event.participantReferences.filter((p) =>
    presentParticipantStatuses.includes(p.status),
  ).length

  const requiredCount = minRaidSize(event, gameVersion)
  if (presentCount >= requiredCount) return 'text-success-foreground'
  if (presentCount >= requiredCount * 0.8) return 'text-warning-foreground'
  return 'text-destructive-foreground'
}
